import React from "react"
import { MoreHorizontal } from "lucide-react"
import { Chk } from "@/components/ui"
import { ils, getRowContent, getRowMenuWrapper, getRowMenuButton } from "./ItemsList.styles"

interface ListRowProps {
    isSelected: boolean
    isHovered: boolean
    onMouseEnter: () => void
    onMouseLeave: () => void
    onCheckboxChange: () => void
    icon: React.ReactNode
    content: React.ReactNode
    onContentClick?: () => void
    onMenuClick: (e: React.MouseEvent<HTMLElement>) => void
    menuActive: boolean
    hideMenu?: boolean
}

export const ListRow: React.FC<ListRowProps> = React.memo(({
    isSelected,
    isHovered,
    onMouseEnter,
    onMouseLeave,
    onCheckboxChange,
    icon,
    content,
    onContentClick,
    onMenuClick,
    menuActive,
    hideMenu,
}) => (
    <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} style={ils.rowWrapper}>
        <div style={getRowContent(isSelected, isHovered)}>
            {/* Checkbox */}
            <div style={ils.rowCheckbox} onClick={(e) => e.stopPropagation()}>
                <Chk checked={isSelected} onChange={onCheckboxChange} size={14} />
            </div>

            {/* Icon */}
            {icon}

            {/* Content */}
            <div style={ils.rowContentArea} onClick={onContentClick}>
                {content}
            </div>

            {/* Menu button */}
            {!hideMenu && (
                <div style={getRowMenuWrapper(isHovered || menuActive)}>
                    <button
                        onClick={(e) => {
                            e.stopPropagation()
                            onMenuClick(e)
                        }}
                        style={getRowMenuButton(menuActive)}
                    >
                        <MoreHorizontal size={14} />
                    </button>
                </div>
            )}
        </div>
    </div>
))
